import { render, staticRenderFns } from "./EmailsForm.vue?vue&type=template&id=20e85f44"
import script from "./EmailsForm.vue?vue&type=script&lang=js"
export * from "./EmailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports